import ApproveCriteria from "../../features/CRUD/approveCriteria/ApproveCriteria"


const ApproveCriteriaPage  = () => {
  return (
    <div>
      <ApproveCriteria />
    </div>
  )
}

export default ApproveCriteriaPage
